import { AerCheckboxGroup as Root } from "./AerCheckboxGroup";

import { AerCheckbox } from "@aerstudios/aerated-aercheckbox/AerCheckbox";

export const AerCheckboxGroup = { Root, Item: AerCheckbox };
